module.exports = __webpack_public_path__ + "static/media/energy-candy.f26a3aa8.png";